import React from 'react';
import { SectionHeader } from './ui/SectionHeader';
import { CtaButton } from './ui/CtaButton';
import { BONUS_TOTAL, CHECKOUT_URL, PRICE, PRODUCT_NAME } from '../data/content';
export function OfferSection() {
  return <section id="oferta" aria-labelledby="oferta-titulo" className="scroll-mt-2 border-b border-crema bg-crema/60" data-id="element-96" data-mp="8mn4mdpzojyr">
      <div className="mx-auto max-w-xl px-4 py-6 sm:py-9" data-id="element-97" data-mp="dfq412hg6nmv">
        <SectionHeader id="oferta-titulo" eyebrow="Oferta especial — Sistema completo 6 en 1" title="Comenzá hoy y avanzá a tu ritmo." data-id="element-98" data-mp="idrmpmayokxt" />

        <div className="mt-4 rounded-2xl border-[3px] border-dashed border-petroleo bg-blanco p-4 text-center shadow-[0_0_0_6px_rgb(var(--dorado)/0.25)] sm:p-5" data-id="element-99" data-mp="rdwp1i1ast54">
          <p className="text-sm font-extrabold text-terracota sm:text-base" data-id="element-100" data-mp="wc817zf2ffqi">✨ {PRODUCT_NAME}</p>
          <p className="text-sm font-bold text-azul" data-id="element-101" data-mp="2t6ued3vv93lb">6 Tomos + 5 Bonos</p>
          <p className="mt-1 text-sm font-medium text-azul" data-id="element-102" data-mp="2y5ffd5ixzrat">🎁 Bonos valorados en {BONUS_TOTAL}</p>

          <p className="mx-auto mt-2.5 inline-block rounded-md bg-terracota px-3 py-1 text-xs font-extrabold uppercase text-blanco" data-id="element-103" data-mp="12ojysjq5ogpg">
            🔥 Oferta especial
          </p>
          <p className="mt-1.5 font-serif text-5xl font-bold leading-none text-azul sm:text-6xl" data-id="element-104" data-mp="sx76xs4cxqjf">
            Hoy: <span className="text-petroleo" data-id="element-105" data-mp="own9enfvgkwr">{PRICE}</span>
          </p>
          <p className="mt-1.5 text-xs font-medium text-azul/75 sm:text-sm" data-id="element-106" data-mp="ouamdvv9bkcu">
            Pago único • Sin mensualidades • Acceso Digital
          </p>

          <CtaButton href={CHECKOUT_URL} className="mt-3" data-id="element-107" data-mp="1gol183m2jw71">
            🚀 Sí, quiero el sistema completo por {PRICE}
          </CtaButton>
          <p className="mt-1.5 text-xs font-medium text-azul/75" data-id="element-108" data-mp="1cniy3bp16zzs">Acceso Inmediato • Garantía de 7 Días</p>
        </div>
      </div>
    </section>;
}